function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import * as actions from '../../../actions';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
const SccConnectionFailed = ({ onSetComponent })=>{
    const onResetScc = useAction(actions.resetScc);
    const onRetry = ()=>{
        onSetComponent('Initializing');
    };
    const onReset = ()=>{
        onResetScc();
        onRetry();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modal__content,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectionFailed.sccHeader))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.illustration,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/connection-failed.svg",
                    className: styles.connectionFailed__img,
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "modal__actions",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.buttons.tryAgain,
                        className: "btn--block mb-4",
                        onClick: onRetry
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.sccInstall.header,
                        className: "btn--block btn--filled",
                        onClick: onReset
                    })
                ]
            })
        ]
    });
};
export default SccConnectionFailed;
